export class angelopolisApi {
  constructor() {
    if (angelopolisApi.instance) {
      return angelopolisApi.instance;
    }
    angelopolisApi.instance = this;
    this.dataAPI = [];
    this.clusters = [];
  }

  async onGetApiData(callBack = () => {}) {
    try {
      const [response, cluster] = await Promise.all([
        fetch("https://www.grupoproyecta.com/backend/api/lote/all/angelopolis"),
        fetch("https://www.grupoproyecta.com/backend/api/clouster/angelopolis"),
      ]);
      const [data, clustersjson] = await Promise.all([
        response.json(),
        cluster.json(),
      ]);
      if (data.payload) {
        this.dataAPI = data?.payload?.lotes;
        this.clusters = clustersjson.payload.clousters;
        callBack();
      } else {
        console.log("error carga de api");
        this.onGetApiData();
      }
    } catch (e) {
      console.log(e);
      console.log("error carga de api");
      this.onGetApiData();
    }
  }

  async onLogin(username, password) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        userName: username,
        password: password,
      }),
    };

    try {
      const response = await fetch(
        "https://www.grupoproyecta.com/backend/api/auth/login",
        requestOptions
      );
      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async onGeneratePDfApi(parmas) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(parmas),
      redirect: "follow",
    };
    try {
      const response = await fetch(
        "https://www.grupoproyecta.com/backend/api/quotemanager/",
        requestOptions
      );
      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error:", error);
    }
  }

  getApiData() {
    return this.dataAPI;
  }
}
